import { memo, useRef, useState } from 'react';
import { addCommas } from '@persian-tools/persian-tools';
import PriceRangeMobile from './priceRangeMobile/PriceRangeMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import Drawer from '@/components/UI/drawer/Drawer';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import styles from './PriceRange.module.scss';
import Menu from '@/components/UI/menu/Menu';
import { useRouter } from 'next/router';
const PriceRange = () => {
  const router = useRouter();
  const [min, max] = [100_000, 300_000_000];
  const [range, setRange] = useState<number[]>([Number(router.query.min_price) * 1000 || min, Number(router.query.max_price) * 1000 || max]);
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('PRICE_RANGE');
  const {
    isMobile
  } = useDevice();
  const closeRef = useRef<any>(null);
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('PRICE_RANGE');
    }
  };
  const handleClose = () => {
    setRange([Number(router.query.min_price) * 1000 || min, Number(router.query.max_price) * 1000 || max]);
    drawerClose();
  };
  const submitData = () => {
    const priceLimit: {
      min_price: number | undefined;
      max_price: number | undefined;
    } = {
      min_price: undefined,
      max_price: undefined
    };
    if (range[0] !== min) {
      priceLimit.min_price = range[0] / 1000;
    }
    if (range[1] !== max) {
      priceLimit.max_price = range[1] / 1000;
    }
    const {
      max_price,
      min_price,
      ...restQueries
    } = router.query;
    const pageContentSet = {
      '/all-boomgardi': {
        boomgardi: 1
      },
      '/all-cottage': {
        cottage: 1
      }
    };
    const pageQuery = pageContentSet[router.pathname] || {};
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        ...restQueries,
        ...Object.keys(priceLimit).reduce((acc, curr) => {
          return {
            ...acc,
            ...(priceLimit[curr] && {
              [curr]: priceLimit[curr]
            })
          };
        }, {})
      }
    });
  };
  const handleClean = e => {
    e.stopPropagation();
    setRange([min, max]);
    const pageContentSet = {
      '/all-boomgardi': {
        boomgardi: 1
      },
      '/all-cottage': {
        cottage: 1
      }
    };
    const pageQuery = pageContentSet[router.pathname] || {};
    router.push({
      pathname: '/search',
      query: {
        ...pageQuery,
        min_price: undefined,
        max_price: undefined
      }
    });
  };
  const checkIsActive = () => {
    if (!!router.query.min_price && +router.query.min_price * 1000 !== min) {
      return true;
    }
    if (!!router.query.max_price && +router.query.max_price * 1000 !== max) {
      return true;
    }
    return false;
  };
  const buttonText = checkIsActive() ? `${router.query.min_price ? ' از ' + addCommas(+router.query.min_price * 1000) : ''} ${router.query.max_price ? ' تا ' + addCommas(+router.query.max_price * 1000) : ''}` : 'قیمت برای هر شب';
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="PriceRange" data-sentry-source-file="PriceRange.tsx">
      <FilterChips type="secondary" checked={checkIsActive()} handleClick={handleClick} handleClean={handleClean} label={buttonText} endIcon name="price_filter" id="price-range-chips" data-sentry-element="FilterChips" data-sentry-source-file="PriceRange.tsx" />

      {!isMobile ? <Menu ref={closeRef} id="price-range" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="price-range-chips" handleAction={() => {
      setRange([Number(router.query.min_price) * 1000 || min, Number(router.query.max_price) * 1000 || max]);
    }}>
          <PriceRangeMobile value={range} onClose={handleClose} setValue={setRange} step={100_000} min={min} max={max} submitData={submitData} resetFilter={handleClean} hasPriceRangeFilter={checkIsActive()} />
        </Menu> : <Drawer open={isDrawerOpen('PRICE_RANGE')} onClose={handleClose}>
          <PriceRangeMobile value={range} onClose={handleClose} setValue={setRange} step={100_000} min={min} max={max} submitData={submitData} resetFilter={handleClean} hasPriceRangeFilter={checkIsActive()} />
        </Drawer>}
    </Box>;
};
export default memo(PriceRange);